<template>
  <CustomDateSelect
    :date="date"
    :time="time"
    :type="type"
    :isDialogOpen="isDialogOpen"
    :minDate="defaultMinDate"
    :maxDate="isRoundTrip && returnDate ? returnDate : defaultMaxDate"
    :minTime="getDefaultMinTime"
    :maxTime="isRoundTrip && isOutwardAndReturnSameDay ? returnTime : null"
    :isRoundTrip="isRoundTrip"
    :isOutward="true"
    :workingHoursZoneWeekDays="workingHoursZoneWeekDays"
    :holidays="holidays"
    :timeZone="timeZone"
    :buttonTextClasses="buttonTextClasses"
    @nextStep="nextStep"
    @closeDialog="closeDialog"
    @updateTime="updateTime"
    @updateDate="updateDate"
    @updateDateType="updateDateType"
  />
</template>

<script lang="ts">
export default {
  name: 'OutwardDateSelection',
};
</script>

<script setup lang="ts">
import { computed, ref } from 'vue';
import moment from 'moment';
import SConstants from '@slg/web-customer-shared/src/utils/constants';
import CustomDateSelect from '@slg/web-customer-shared/src/components/bookingForm/datesSelection/CustomDateSelect.vue';

const props = defineProps({
  outwardState: {
    type: Object,
    default: null,
  },
  returnTime: {
    type: String,
    default: null,
  },
  returnDate: {
    type: String,
    default: null,
  },
  holidays: {
    type: Array,
    default: () => [],
  },
  minTimeBeforeBooking: {
    type: Number,
    default: null,
  },
  isRoundTrip: {
    type: Boolean,
    default: false,
  },
  defaultMaxDate: {
    type: String,
    default: null,
  },
  defaultMinDate: {
    type: String,
    default: null,
  },
  workingHoursZoneWeekDays: {
    type: Array,
    default: () => [],
  },
  dateNow: {
    type: Object,
    default: null,
  },
  timeZone: {
    type: String,
    default: null,
  },
  buttonTextClasses: {
    type: String,
    default: 'textWhite--text',
  },
});

const emit = defineEmits(['setOutwardDate', 'changeStep', 'closeDialog']);

const isDialogOpen = ref(false);
const isOutwardNow = ref(false);
const time = ref(null);
const date = ref(null);
const type = ref(null);

const isOutwardAndReturnSameDay = computed(() => props.returnDate === date.value);

const getDefaultMinTime = computed(() => {
  const minTime = props.dateNow.clone().tz(props.timeZone);
  return moment(minTime).format(SConstants.TIME_FORMAT.YYYY_MM_DD) ===
    date.value
    ? minTime
        .add(props.minTimeBeforeBooking, 'minutes')
        .format(SConstants.TIME_FORMAT.HH_mm)
    : null;
});

const { date: outwardDate, time: outwardTime, type: outwardType } = props.outwardState;
date.value = outwardDate;
time.value = outwardTime;
type.value = outwardType;

function updateDate(newValue) {
  date.value = newValue;
}

function updateDateType(newValue) {
  type.value = newValue;
}

function updateTime(newValue) {
  time.value = newValue;
}

function nextStep(name) {
  const outwardDatePayload = {
    date: date.value,
    time: time.value,
    type: type.value,
  };
  emit('setOutwardDate', outwardDatePayload);
  if (props.isRoundTrip) {
    emit('changeStep', name);
  } else {
    emit('closeDialog');
  }
}

function closeDialog() {
  emit('closeDialog');
}
</script>
<style lang="scss" scoped>
</style>
